<br><br><br><br><br><br><br><br>
<p>
  FormPostulanteNested works!
</p>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <!-- <form class="bg-light p-3" 
            autocomplete="off"
            (ngSubmit)="guardar()"
            #miFormulario="ngForm">
        <div class="row">
          <label class="col-md-3" >Nombre</label>
          <div class="col-md-9">
            <input type="text" class="form-control"
                    required
                    [(ngModel)]="persona.nombre"
                    name="nombre">
            <small class="text-danger"
                   *ngIf="miFormulario.controls.nombre?.errors && miFormulario.controls.nombre?.touched" >Es requerido</small>
          </div>
        </div>
        
        

        <div class="row mt-3">
          <label class="col-sm-3 col-form-label">Agregar</label>
          <div class="col-sm-9">
            <div class="input-group">
              <input type="text" class="form-control"
              [(ngModel)]="nuevoJuego" 
              name="nuevoJuego"
              (keyup.enter)="agregarFavorito()">
              <button type="button" class="btn btn-outline-danger"
                      (click)="agregarFavorito()">Agregar Favorito</button>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <label class="col-sm-3 col-label-form">Favoritos</label>
          <div class="col-sm-9">
            <div class="input-group mb-1" *ngFor="let juego of persona.favoritos; let i = index">
              <input type="text" 
                [(ngModel)]="juego.nombre"
                name="juego_{{i}}"
                class="form-control"
                >
                <button type="button" class="btn btn-danger" (click)="eliminarFavorito(i)">Eliminar</button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <button type="button" 
                    [disabled]="miFormulario.invalid"
                    class="btn btn-primary float-right mt-3"
                    (click)="guardar()">Guardar</button>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-md-12 bg-light m-3">
          <span>Persona: </span>
          <pre>{{ persona | json }}</pre>
        </div>
      </div>-->

      <form class="bg-light p-3" 
            autocomplete="off"
            (ngSubmit)="guardar()"
            #miFormulario="ngForm">
        <div class="row">
          <label class="col-md-3" >Nombre</label>
          <div class="col-md-9">
            <input type="text" class="form-control"
                    required
                    [(ngModel)]="postulante.name"
                    name="name">
            <small class="text-danger"
                   *ngIf="miFormulario.controls.name?.errors && miFormulario.controls.name?.touched" >Es requerido</small>
          </div>
        </div>
        <div class="row mt-3">
          <label class="col-sm-3 col-form-label">Agregar</label>
          <div class="col-sm-9">
            <div class="input-group">
              <input type="text" class="form-control"
              [(ngModel)]="nuevoJuego" 
              name="nuevoJuego"
              (keyup.enter)="agregarFavorito()">
              <button type="button" class="btn btn-outline-danger"
                      (click)="agregarFavorito()">Agregar Favorito</button>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <label class="col-sm-3 col-label-form">Favoritos</label>
          <div class="col-sm-9">
            <div class="input-group mb-1" *ngFor="let juego of postulante.favoritos; let i = index">
              <input type="text" 
                [(ngModel)]="juego.nombre"
                name="juego_{{i}}"
                class="form-control"
                >
                <button type="button" class="btn btn-danger" (click)="eliminarFavorito(i)">Eliminar</button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <button type="button" 
                    [disabled]="miFormulario.invalid"
                    class="btn btn-primary float-right mt-3"
                    (click)="guardar()">Guardar</button>
          </div>

        </div>
        <div class="row">
          <button [disabled]="miFormulario.form.invalid" 
                  role="button" 
                  class="btn btn-primary" 
                  (click)='crearPostulante()' 
                  *ngIf="!postulante.id else elseBlock" >Guardar</button>
        <ng-template #elseBlock>
          <button class="btn btn-primary" role="button" (click)="actualizarPostulante()">Actualizar</button>
        </ng-template>
        </div>
      </form>
      <div class="row">
        <div class="col-md-12 bg-light m-3">
          <span>Postulante: </span>
          <pre>{{ postulante | json }}</pre>
        </div>
      </div>
    </div>
  </div>
</div>
